import axios from 'axios'
import store from '../../store/store'

const apiUrl = process.env.API_URL

const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

axiosInstance.interceptors.request.use(
  function(config) {
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.dispatch('logOut')
    }
    throw error
  }
)

export default axiosInstance



// WEBPACK FOOTER //
// ./src/pkg/api/axios.js